import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { t } from '../../../common/i18n/index.js';
import type { ProductOfferingCharacteristic } from '../../../generated/api/productOfferingCharacteristic.js';

interface AdditionalFeaturesContentProps {
  additionalFeatures: ProductOfferingCharacteristic[];
}

export const AdditionalFeaturesContent = ({ additionalFeatures }: AdditionalFeaturesContentProps) => {
  const featuresWithValue = additionalFeatures.filter(feature => feature.value?.[0]?.value);

  if (featuresWithValue.length === 0) {
    return null;
  }

  return (
    <div className="of-subscription-card-content-additional-features">
      <CL.Accordion className={`${dsClass.MARGIN_TOP_2}`}>
        <CL.AccordionItem
          heading={
            <h5 className={dsClass.MARGIN_0}>{`${t.Y2TH('Additional features')} (${featuresWithValue.length})`}</h5>
          }
        >
          <ul className={`of-two-column-flex ${dsClass.MARGIN_TOP_3}`}>
            {featuresWithValue.map(feature => (
              <li key={feature.name}>
                <CL.Icon className="of-info-icon" icon="check" size="s" />
                <span className={`of-info-item-text ${dsClass.TEXT_S}`}>{feature.value?.[0]?.value}</span>
              </li>
            ))}
          </ul>
        </CL.AccordionItem>
      </CL.Accordion>
    </div>
  );
};
